<template>
	<div
		class="g-block-pay-jumplink"
		:class="{
			'g-block-pay-jumplink--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink--fixed-viewport': fixedBottom && !editable,
			'g-block-pay-jumplink--fixed-slot': fixedBottom && editable,
			'g-block-pay-jumplink--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-pay-jumplink__card" :style="cardStyle">
			<div class="g-block-pay-jumplink__left">
				<div class="g-block-pay-jumplink__icon" :style="iconStyle">
					<img
						v-if="iconImageUrl"
						:src="iconImageUrl"
						class="g-block-pay-jumplink__icon-img"
						alt=""
					/>
					<i v-else :class="['mbm-iconfont', data.icon || 'mbm-tupian1']"></i>
				</div>
			</div>
			<div class="g-block-pay-jumplink__info">
				<p class="g-block-pay-jumplink__title">{{ data.title || 'AI创业交流群' }}</p>
				<p class="g-block-pay-jumplink__subtitle">{{ data.subtitle || '每天更新实操案例' }}</p>
				<div class="g-block-pay-jumplink__status">
					<div class="g-block-pay-jumplink__status-icon">
						<img
							v-if="statusIconImageUrl"
							:src="statusIconImageUrl"
							class="g-block-pay-jumplink__status-icon-img"
							alt=""
						/>
						<i v-else :class="['mbm-iconfont', data.statusIcon || 'mbm-iconfont mbm-xiaofenger']"></i>
					</div>
					<span class="g-block-pay-jumplink__status-text">
						{{ data.statusText || '当前 2368 人在群' }}
					</span>
				</div>
			</div>
			<div class="g-block-pay-jumplink__action">
				<div class="g-block-pay-jumplink__right">
					<span v-if="!isGeditModulePaid && !shouldHidePrice" class="g-block-pay-jumplink__price" :style="priceColor">¥ {{ displayPrice }}</span>
					<div
						class="g-block-pay-jumplink__btn"
						:style="buttonStyle"
						@click.stop="onButtonClick"
					><span class="g-block-pay-jumplink__btn-text">{{ (isGeditModulePaid ? data.unlockedButtonText : '') || data.buttonText || '申请加入' }}</span> <span class="mbm-iconfont mbm-youjiantou1"></span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { getQiniuSignedUrl } from '../../../utils/qiniuMedia.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLink',
		components: { PayUnlockShell },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_JUMPLINK;
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_JUMPLINK);
			},
			priceColor() {
				return { color: '#fff' };
			},
			buttonStyle() {
				if (this.isGeditModulePaid) {
					return {
						background: '#fff',
						color: this.btnColor,
					};
				}
				return {
					background: 'rgba(255,255,255,1)',
					color: this.btnColor
				};
			},
			iconStyle() {
				return {};
			},
			iconImageUrl() {
				const icon = this.data.iconImage;
				if (!icon) return '';
				if (typeof icon === 'string') return getQiniuSignedUrl(icon);
				return getQiniuSignedUrl(icon.previewUrl || icon.url || '');
			},
			statusIconImageUrl() {
				const icon = this.data.statusIconImage;
				if (!icon) return '';
				if (typeof icon === 'string') return getQiniuSignedUrl(icon);
				return getQiniuSignedUrl(icon.previewUrl || icon.url || '');
			},
			cardStyle() {
				return {
					background: `linear-gradient(135deg, ${this.btnColor} 0%, ${this.btnColor}dd 100%)`,
				};
			},
		},
		methods: {
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLink: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink {

		&--fixed-viewport,
		&--fixed-slot {
			padding: 0;
		}

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&--h5 {

			&.g-block-pay-jumplink--fixed-viewport,
			&.g-block-pay-jumplink--fixed-slot {
				padding: 0;
			}
		}
	}

	.g-block-pay-jumplink__card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		border-radius: 10px;
		padding: 10px 10px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}

	.g-block-pay-jumplink__left {
		flex-shrink: 0;
	}

	.g-block-pay-jumplink__icon {
		width: 60px;
		height: 60px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		overflow: hidden;
	}

	.g-block-pay-jumplink__icon-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.g-block-pay-jumplink__icon .mbm-iconfont {
		font-size: 20px;
		color: #fff;
	}

	.g-block-pay-jumplink__info {
		flex: 1;
		min-width: 0;
	}

	.g-block-pay-jumplink__title {
		margin: 0;
		font-size: 15px;
		font-weight: 700;
		color: #fff;
		line-height: 1.4;
	}

	.g-block-pay-jumplink__subtitle {
		margin: 3px 0 0;
		font-size: 10px;
		color: rgba(255, 255, 255, 0.8);
		line-height: 1.4;
	}

	.g-block-pay-jumplink__status {
		margin: 3px 0 0;
		font-size: 10px;
		color: rgba(255, 255, 255, 0.8);
		line-height: 1.4;
	}

	.g-block-pay-jumplink__action {
		flex-shrink: 0;
		display: flex;
		align-items: center;
	}

	.g-block-pay-jumplink__right {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 8px;
	}

	.g-block-pay-jumplink__price {
		font-size: 20px;
		font-weight: 700;
		margin: 0 auto;
		line-height: 1.2;
	}

	.g-block-pay-jumplink__btn {
		height: 30px;
		padding: 0 16px;
		border: none;
		border-radius: 999px;
		font-size: 12px;
		font-weight: 700;
		cursor: pointer;
		white-space: nowrap;
		text-align: center;
		display: flex;
		align-items: center;
	}

	.g-block-pay-jumplink--h5 {
		.g-block-pay-jumplink__card {
			gap: 0.24rem;
			border-radius: 0.2rem;
			padding: 0.2rem;
		}

		.g-block-pay-jumplink__icon {
			width: 1.2rem;
			height: 1.2rem;
			border-radius: 0.16rem;
		}

		.g-block-pay-jumplink__icon .mbm-iconfont {
			font-size: 0.36rem;
		}

		.g-block-pay-jumplink__title {
			font-size: 0.28rem;
		}

		.g-block-pay-jumplink__subtitle,
		.g-block-pay-jumplink__status {
			font-size: 0.22rem;
			margin: 0.06rem 0 0;

		}

		.g-block-pay-jumplink__right {
			gap: 0.16rem;
		}

		.g-block-pay-jumplink__price {
			font-size: 0.4rem;
		}

		.g-block-pay-jumplink__btn {
			height: 0.6rem;
			padding: 0 0.32rem;
			font-size: 0.24rem;
		}
	}
</style>
